import { ActionReducer, Action } from '@ngrx/store';
import { CurrentBookingReducer } from '../models/current-booking-reducer.interface';

export const UPDATE_BOOKING_OBJECT = 'UPDATE_BOOKING_OBJECT';
export const UPDATE_AMEND_OBJECT = 'UPDATE_AMEND_OBJECT';
export const REFRESH_BOOKING_OBJECT = 'REFRESH_BOOKING_OBJECT';
export const RESET_BOOKING_OBJECT = 'RESET_BOOKING_OBJECT';
export const UPDATE_ZONE_ID = 'UPDATE_ZONE_ID';
export const UPDATE_TIMESLOT_SERVICE_DATE = 'UPDATE_TIMESLOT_SERVICE_DATE';

export interface ActionWithPayloadInterface extends Action {
  payload: any;
}

const initState: CurrentBookingReducer = {
  currentBooking: {},
  amendBooking: {},
  timeSlotServiceDate: ''
};

export function currentBookingReducer (state: CurrentBookingReducer = initState, action: ActionWithPayloadInterface) {

 switch (action.type) {

    case UPDATE_BOOKING_OBJECT:
      return Object.assign({}, state, { currentBooking: action.payload });

    case UPDATE_AMEND_OBJECT:
      return Object.assign({}, state, { amendBooking: action.payload });

    case REFRESH_BOOKING_OBJECT:
      state = Object.assign({}, action.payload);
      return state;

    case RESET_BOOKING_OBJECT:
      state = Object.assign({}, initState);
     return state;

    case UPDATE_TIMESLOT_SERVICE_DATE:
     return Object.assign({}, state, {timeSlotServiceDate: action.payload});
    default:
      return state;
  }

};
